<template>
  <div class="">
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>

    <div v-else>
      <div class="ui grid">
        <div class="left aligned five wide column">
          <!-- <div class="ui very compact left floated medium red button"
               style="background-color: #092442; margin-top: 8px"
               @click="restoreDoctor()"
               v-if="doctor.deleted_at && doctor.user.id !== $auth.user().id">
            {{ $t('restore') }}
          </div> -->
        </div>

        <div class="left aligned eleven wide column">
          <h1 class="ui left aligned icon fluid  header" style="color: #092442">
            {{$t('doctor') }} {{ doctor.user.name }}
          </h1>
        </div>

        <div class="left aligned column"></div>
      </div>


      <div class="ui divider" style="margin-top: -40px"></div>

      <div class="ui grid container" style="padding-top: 15px">
        <div class="four wide column">
          <div class="ui grid"> 
            <div class="row">
              <div class="column centered-header"> 
                <imageComponent :object="doctor"
                                :sendingURL="'doctors/' + doctor.id + '/add/image'">
                </imageComponent>
              </div>
            </div>
            <div class="row" v-if="clinicId && useFinancial && (isMine(doctor.user.id) || $auth.user().see_invoices)">
              <div class="column"> 
                <div class="ui medium blue fluid button"
                    v-if="$auth.check('doctor')"
                    @click="navigateTo('Doctor_Report', {params: {id: doctor.id}})">
                  <i class="industry icon"></i>
                  Doctor Report
                </div>
              </div>
            </div>
            <div 
              class="row" 
              style="margin-top: -20px;" 
              v-if="clinicId && (isMine(doctor.user.id) || $auth.user().see_invoices) && useFinancial"
            >
              <div class="column"> 
                <div class="ui medium blue fluid button"
                    v-if="$auth.check('doctor')"
                    @click="navigateTo('Percentages', {params: {id: doctor.id}})">
                  <i class="percent icon"></i>
                  Percentages
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="twelve wide column" >
          <h4 class="ui dividing header">
            {{ $t('personalInfo') }}
          </h4>
          <abstractTable :data="doctorInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('contactInfo') }}
          </h4>
          <abstractTable :data="contactInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('jobInfo') }}
          </h4>
          <abstractTable :data="jobInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>
        </div>
      </div>

      <div class="ui divider"></div>

      <div class="ui three columns grid" style="padding-bottom: 5px">
        <div class="row">
          <div class="column"></div>
          <div class="left aligned column">
            <h1 class="ui center aligned header" style="color: #092442">
              <i class="open folder icon"></i>
              {{$t('reservations') }}
            </h1>
            <div class="ui divider"></div>
          </div>
          <div class="column">
          </div>
        </div>
      </div>

      <reservationsPart :doctor="doctor"></reservationsPart>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    imageComponent: require('@/components/abstract_components/Image').default,
    reservationsPart: require('@/components/doctors/doctor_components/ReservationsPart').default
  },
  data () {
    return {
      doctor: {},
      loading: true
    }
  },
  beforeMount () {
    this.getDoctor()
  },
  watch: {
    doctor: {
      handler: function () {
        if (this.doctor.user.id === this.$auth.user().id) {
          if (this.$auth.user().images.length < this.doctor.album.images.length) {
            this.$auth.user().images = this.doctor.album.images
          } else {
            this.doctor.album.images = this.$auth.user().images
          }
        }
      },
      deep: true
    }
  },
  computed: {
    clinicId () {
      return this.getFromLocalStorage('clinicId')
    },
    useFinancial() {
      return this.permissions.financial_permissions.used
    },
    doctorInfo () {
      return {
        [this.$t('nationalId')]: this.doctor.national_id,
        [this.$t('age')]: this.getAge(this.doctor.user.date_of_birth),
        [this.$t('gender')]: this.getGender(this.doctor.user.gender),
        [this.$t('maritalStatus')]: this.getMaritalStatus(this.doctor.marital_status),
        [this.$t('address')]: this.doctor.user.address
      }
    },
    contactInfo () {
      return {
        [this.$t('email')]: this.doctor.user.email,
        [this.$t('phone')]: this.doctor.user.home_phone,
        [this.$t('mobile')]: this.doctor.user.mobile
      }
    },
    jobInfo () {
      return {
        [this.$t('specialization')]: this.doctor.specialization.name,
        [this.$t('workStatus')]: this.doctor.deleted_at
          ? this.$t('archived') : this.$t('heIsStillWorking')
      }
    }
  },
  methods: {
    getDoctor () {
      this.$http.get(`doctors/${this.$route.params.id}`).then(response => {
        this.doctor = response.data
        this.loading = false
      })
    },
    archiveDoctor () {
      this.$swal({
        title: `${this.$t('youAreGoingToArchive')} ${this.doctor.user.name}`,
        type: 'warning',
        confirmButtonText: `${this.$t('yes,Archive')}`,
        confirmButtonColor: '#092442',
        preConfirm: () => {
          return this.$http.post(`users/${this.doctor.user.id}/archive`).then(response => {
            this.getDoctor()
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: `${this.$t('archived')}!`,
            type: 'success'
          })
        }
      })
    },
    restoreDoctor () {
      this.$swal({
        title: `${this.$t('youAreGoingToRestore')} ${this.doctor.user.name}`,
        type: 'warning',
        confirmButtonText: `${this.$t('yes,Restore')}`,
        confirmButtonColor: '#092442',
        preConfirm: () => {
          return this.$http.post(`users/${this.doctor.user.id}/restore`).then(() => {
            this.getDoctor()
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: `${this.$t('restored')}!`,
            type: 'success'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.price-popup {
  cursor: pointer;
  color: #2185d0 !important;
}
.centered-header {
  display: flex !important;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/doctors/Doctor.vue